import React from 'react';
import { Monitor, User } from 'grommet-icons';

// stickers list
export const Row1 = [
  {
    img: '/img/hackshack/StickerPage/metalhand.png',
    icon: <Monitor size="small" />,
    backgroundColor: 'background-contrast',
  },
  {
    img: '/img/hackshack/StickerPage/gremlinrockin.png',
    icon: <Monitor size="small" />,
    backgroundColor: '#FFBC44',
  },
  {
    img: '/img/hackshack/StickerPage/grommet-sticker.png',
    icon: <Monitor size="small" />,
    backgroundColor: '#FFFFFF',
  },
  {
    img: '/img/hackshack/StickerPage/it-monster.png',
    icon: <User size="small" />,
  },
  // take out after Ezmeral is announced
  //   {
  //     img: '/img/hackshack/StickerPage/grommet-sticker-kisscut.png',
  //     icon: <User size="small" />,
  //   },
  // put back in ezmeral picture
  {
    img: '/img/hackshack/StickerPage/ezmeral.png',
    icon: <User size="small" />,
  },
];

export const Row2 = [
  {
    img: '/img/hackshack/StickerPage/06-HackShack.png',
    icon: <Monitor size="small" />,
    size: 'large',
  },
  {
    img: '/img/hackshack/StickerPage/gremlin-cube-transparent.png',
    icon: <Monitor size="small" />,
  },
  // {
  //   img: '/img/hackshack/StickerPage/hpedevlogo.png',
  //   icon: <Monitor size="small" />,
  // },
  {
    img: '/img/hackshack/StickerPage/gremlin.png',
    icon: <User size="small" />,
  },
  {
    backgroundImage: 'url(/img/hackshack/StickerPage/grommet-icon.png)',
    download: '/img/hackshack/StickerPage/grommet-icon.png',
    icon: <Monitor size="small" />,
  },
];

export const Row3 = [
  {
    backgroundColor: '#82FFF2',
    icon: <User size="small" />,
    img: '/img/hackshack/StickerPage/gremlinhat.png',
  },
  {
    // Take out img and put back background Image & download
    backgroundImage: 'url(/img/hackshack/StickerPage/ezmeralbackground.png)',
    download: '/img/hackshack/StickerPage/ezmeralbackground.png',
    icon: <Monitor size="small" />,
    size: 'large',
    // img: '/img/hackshack/StickerPage/dev-sticker-light.png',
    // icon: <Monitor size="small" />,
    // size: 'large',
  },
  {
    img: '/img/hackshack/StickerPage/letshackshack.png',
    icon: <Monitor size="small" />,
    size: 'large',
  },
];

export const Row4 = [
  {
    img: '/img/hackshack/StickerPage/itmonsterattack.png',
    icon: <Monitor size="small" />,
  },
  // {
  //   icon: <User size="small" />,
  //   img: '/img/hackshack/StickerPage/devlogo.png',
  // },
  {
    backgroundImage: 'url(/img/hackshack/StickerPage/2gremlins.png)',
    download: '/img/hackshack/StickerPage/2gremlins.png',
    icon: <Monitor size="small" />,
    size: 'large',
  },
  {
    backgroundImage: 'url(/img/hackshack/StickerPage/hack-shack-house.png)',
    download: '/img/hackshack/StickerPage/hack-shack-house.png',
    icon: <Monitor size="small" />,
    size: 'large',
  },
];

export const Row5 = [
  {
    backgroundColor: 'black',
    icon: <Monitor size="small" />,
    img: '/img/hackshack/StickerPage/attack-marquee.svg',
    size: 'large',
  },
  {
    backgroundImage: 'url(/img/hackshack/StickerPage/design.png)',
    download: '/img/hackshack/StickerPage/design.png',
    icon: <Monitor size="small" />,
  },
  // {
  //   icon: <User size="small" />,
  //   img: '/img/hackshack/StickerPage/dev-thumb.png',
  // },
  {
    img: '/img/hackshack/StickerPage/gremlin-cube.jpeg',
    backgroundColor: 'white',
    icon: <Monitor size="small" />,
  },
  {
    backgroundImage: 'url(/img/hackshack/StickerPage/heart.png)',
    download: '/img/hackshack/StickerPage/heart.png',
    icon: <User size="small" />,
  },
];

export const Row6 = [
  {
    img: '/img/hackshack/StickerPage/ResearchDesignDev.png',
    backgroundColor: 'white',
    icon: <Monitor size="small" />,
    size: 'large',
  },
  {
    img: '/img/hackshack/StickerPage/designedwlove.png',
    icon: <Monitor size="small" />,
    size: 'large',
  },
];

export const Row7 = [];

// Need extra rows for mobile view
export const Row8 = [
  {
    backgroundImage: 'url(/img/hackshack/StickerPage/grommet-icon.png)',
    download: '/img/hackshack/StickerPage/grommet-icon.png',
    icon: <Monitor size="small" />,
  },
  {
    backgroundImage: 'url(/img/hackshack/StickerPage/heart.png)',
    download: '/img/hackshack/StickerPage/heart.png',
    icon: <User size="small" />,
  },
  {
    img: '/img/hackshack/StickerPage/designedwlove.png',
    icon: <Monitor size="small" />,
    size: 'large',
  },
];

export const Row9 = [
  {
    img: '/img/hackshack/StickerPage/letshackshack.png',
    icon: <Monitor size="small" />,
    size: 'large',
  },
  {
    backgroundImage: 'url(/img/hackshack/StickerPage/hack-shack-house.png)',
    download: '/img/hackshack/StickerPage/hack-shack-house.png',
    icon: <Monitor size="small" />,
    size: 'large',
  },
];
